import React, { useCallback } from "react";

import FreightModeButton from "components/organisms/FreightModeButton/FreightModeButton";
import { useGetCommonFreightModes } from "api/queries/common/useGetCommonFreightModes";

type FreightModeFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
  filterValueKey?: string;
};

function FreightModeFilter(props: FreightModeFilterProps) {
  const { currentFilters, setFilters, filterKey, filterValueKey = "key" } = props;
  const { data: freightModes } = useGetCommonFreightModes({
    includeCustom: true,
    options: {
      select: useCallback(
        (data: any) =>
          data.map((freightMode: any) => ({
            ...freightMode,
            translated_value: freightMode.translated_value || freightMode.value,
          })),
        [],
      ),
    },
  });

  const handleSelect = (e: React.MouseEvent<HTMLButtonElement>, currentOption: any) => {
    e.stopPropagation();
    if (!currentFilters[filterKey] || !currentFilters[filterKey]?.includes(currentOption[filterValueKey])) {
      setFilters({
        ...currentFilters,
        [filterKey]: Array.isArray(currentFilters[filterKey])
          ? [...currentFilters[filterKey], currentOption[filterValueKey]]
          : [currentOption[filterValueKey]],
      });
    } else {
      setFilters({
        ...currentFilters,
        [filterKey]: currentFilters[filterKey].filter((item: any) => item !== currentOption[filterValueKey]),
      });
    }
  };

  return (
    <div className="freight-mode-filter">
      {freightModes?.map((freightMode: any) => {
        const isSelected = !!currentFilters[filterKey]?.includes(freightMode[filterValueKey]);
        return (
          <FreightModeButton
            key={freightMode.value}
            isSelected={isSelected}
            onClick={(e) => handleSelect(e, freightMode)}
            value={freightMode.value}
            label={freightMode.translated_value ?? freightMode.value}
            type={freightMode.freight_mode_type}
            modeValue={freightMode.key ?? freightMode.value}
          />
        );
      })}
    </div>
  );
}

export default FreightModeFilter;

FreightModeFilter.defaultProps = {
  filterValueKey: "key",
};
